<template>
    <div>
        <!-- 视频列表 -->
        <div class="video-mask" v-if="showAllVedio">
            <div class="vedio-box" v-if="!isNew">
                <img class="bg" src="./../../assets/video-bg.png" alt="">
                <span class="box-title">选择视频</span>
                <img class="close" src="./../../assets/video-close.png" alt="" @click="$emit('closeShow')">
                <div class="video-list" >
                    <div class="video-item" v-for="(item, index) in vedio" :key="item.video_title" @click="playVideo(index)">
                        <img :src="item.video_img" mode="aspectFill" class="video-img" />
                        <span class="video-title" >{{ item.video_title }}</span>
                    </div>
                </div>
            </div>
            <div class="new-video-box" v-else>
                <div class="new-video-title">
                    <span class="tit">选择视频</span>
                    <div class="new-video-close" @click="$emit('closeShow')"></div>
                </div>
                <div class="languages">
                    <div class="video-list" >
                        <div class="video-item" v-for="(item, index) in vedio" :key="item.video_title" @click="playVideo(index)">
                            <img :src="item.video_img" mode="aspectFill" class="video-img" />
                            <span class="video-title" >{{ item.video_title }}</span>
                        </div>
                    </div>
                    <div class="wave"></div>
                </div>
            </div>
        </div>
        <!-- 弹出视频遮罩层 -->
        <div class="video-play" v-if="showVedio">
            <div class="video-play-mask" @click="hideVideo"></div>
            <div class="video-player">
                <iframe class="video"
                    style="z-index:1;" 
                    :src="'https://v.qq.com/iframe/player.html?vid=' + video_tencent_id + '&amp;height=210&amp;auto=true'"
                    allowfullscreen="" frameborder="0" height="210" v-if="video_tencent_id"></iframe> <!-- &amp;width=' + width + '   :width="width" -->
                <video :src="curVedio" class="video" :controls="true" :autoplay="true"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 视频列表
        vedio: {
            type: Array
        },
        // 是否显示视频列表
        showAllVedio: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            curVedio: '', // 当前正在播放的视频地址
            showVedio: false, // 是否展示视频
            // 腾讯视频id
            video_tencent_id: '',
            width: ''
        }
    },
    computed: {
        isNew() {
            return this.$store.state.isNew
        }
    },
    methods: {
        hideVideo(){
            this.curVedio = ''
            this.showVedio = false
            this.video_tencent_id = ''
        },
        playVideo(idx){
            this.curVedio = this.vedio[idx].video_link
            const playVideo = this.vedio[idx]
            // 腾讯视频
            if(playVideo.video_species && playVideo.video_species.value == 3) {
                this.video_tencent_id = playVideo.video_tencent_id
                this.curVedio = ''
            } else {
                this.curVedio = playVideo.video_link
                this.video_tencent_id = ''
            }
            this.showVedio = true
        }
    }
}
</script>

<style lang="scss" scoped>

.video-mask {
    z-index: 10000;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
    // box-sizing: border-box;
    background: rgba($color: #232323, $alpha: .64);
    text-align: left;
    .vedio-box {
        background: #FFFFFF;
        border-radius: .5rem;
        width: 5.74rem;
        position: absolute;
        top: 4rem;
        left: 50%;
        transform: translate(-50%, 0);
        .bg {
            width: 100%;
        }
        .box-title {
            position: absolute;
            left: 2.32rem;
            top: .5rem;
            display: inline-block;
            font-size: .36rem;
            font-weight: bold;
            color: #FFFFFF;
        }
        .close {
            position: absolute;
            right: .25rem;
            top: .25rem;
            width: .4rem;
            height: .4rem;
        }
        .video-list {
            height: 5.5rem;
            overflow-y: auto;
            margin-top: -.3rem;
            .video-item {
                display: flex;
                align-items: center;
                padding: .25rem .34rem;
                .video-img {
                    width: 1.28rem;
                    height: 1.28rem;
                    border-radius: .2rem;
                    margin-right: .2rem;
                }
                .video-title {
                    font-size: .26rem;
                    font-weight: bold;
                    color: #333333;
                }
            }
        }
    }
    
	.new-video-box {
		width: 6.00rem;
		// height: 3.44rem;
		border-radius: .20rem;
		position: fixed;
		top: 50%;
		left: 0;
		right: 0;
		transform: translateY(-50%);
		margin: auto;
		padding-bottom: .10rem;
		z-index: 222;
		image {
			width: 100%;
			height: 100%;
		}
		.new-video-title {
			position: relative;
			text-align: center;
			font-size: .36rem;
			font-weight: bold;
			color: #fff;
			padding-top: .20rem;
			height: 2.40rem;
			background: url(https://scenic.test.tuliyou.com/upload/uediter/image/20240418/1713423468849415.png) 0 0 / 100% 100% no-repeat;
			.tit {
				font-weight: bold;
				font-size: .36rem;
				color: #FFFFFF;
				position: absolute;
				right: 1.26rem;
				top: .95rem;
			}
			.play-icon {
				width: .46rem;
				height: .46rem;
				position: absolute;
				top: .23rem;
				right: 1.06rem;
			}
			.new-video-close {
				width: .40rem;
				height: .40rem;
				// background: url("../../assets/audio-close.png") no-repeat center;
				background-size: cover;
				position: absolute;
				top: .23rem;
				right: .33rem;

				
				width: .32rem;
				height: .32rem;
				right: .30rem;
				top: 1.06rem;
				background: url(https://scenic.test.tuliyou.com/upload/uediter/image/20240418/1713423570375334.png) 0 0 / 100% 100% no-repeat;
			}
		}
		.languages {
			width: 100%;
			min-height: 2.40rem;
			background: #ffffff;
			border-radius: .20rem;
			margin-top: .10rem;
			position: relative;

			
			background: #F5F3EB;
			border-radius: 0 0 .30rem .30rem;
			padding-bottom: .20rem;
            
            .video-list {
                height: 5.50rem;
                overflow-y: auto;
                margin-top: -.30rem;
                .video-item {
                    display: flex;
                    align-items: center;
                    padding: .25rem .34rem;
                    .video-img {
                        width: 1.28rem;
                        height: 1.28rem;
                        border-radius: .20rem;
                        margin-right: .20rem;
                    }
                    .video-title {
                        font-size: .26rem;
                        font-weight: bold;
                        color: #333333;
                    }
                }
            }
			.wave {
				width: 100%;
				height: .68rem;
				position: absolute;
				bottom: 0;
				left: 0;
				pointer-events: none;
				
				width: .60rem;
				height: .38rem;
				left: 4.45rem;
				background: url(https://scenic.test.tuliyou.com/upload/uediter/image/20240418/1713423570543494.png) 0 0 / 100% 100% no-repeat;
			}
		}
	}
}



.video-play {
	z-index: 10000;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
  .video-play-mask{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .8);
  }
  .video-player {
    overflow: hidden;
    position: absolute;
    top: calc(50% - 2rem);
    margin: 0 auto;
    width: 100%;
    height: 4rem;
    text-align: center;
    box-shadow: 0 .1rem .2rem 0 rgba(0, 0, 0, .3);
    .video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>